module.exports = __webpack_public_path__ + "img/shop_similar_icon_v1.67ba9b3.svg";